<template>
  <b-modal
    id="documents-modal"
    ref="modal"
    :title="title"
    @hidden="onClose"
    size="lg"
  >
    <ValidationObserver
      ref="documentsForm"
      tag="form"
      id="documentsForm"
      @submit.prevent="onSubmit"
    >
      <b-form-group
        label-cols-lg="3"
        label="Nazwa:"
        label-for="document_name"
        label-align-lg="right"
      >
        <ValidationProvider name="document_name" v-slot="validationContext">
          <b-form-input
            id="document_name"
            v-model="document_name"
            type="text"
          ></b-form-input>
          <b-form-invalid-feedback :force-show="true"
            >&nbsp;{{ validationContext.errors[0] }}</b-form-invalid-feedback
          >
        </ValidationProvider>
      </b-form-group>

      <ValidationProvider name="document" v-slot="validationContext">
        <b-form-group
          v-if="(!isEdited && !file) || (isEdited && !file)"
          label-cols-lg="3"
          label="Dokument:"
          label-for="file"
          label-align-lg="right"
        >
          <label class="col" for="file" id="filelabel">
            <div
              class="dropfile"
              @drop="dropFile"
              @dragover="dragover"
              @dragleave="dragleave"
            >
              <div class="d-flex flex-wrap">
                <div class="dropfile-icon">
                  <i class="fas fa-file-word"></i>
                </div>
                <div class="dropfile-text">
                  <h5>Przeciągnij i upuść plik, aby go dodać</h5>
                </div>
              </div>
              <input
                ref="document"
                type="file"
                name="document"
                id="file"
                class="inputfile"
                @input="onFileChange"
              />
              <span class="btn btn-primary mt-3">Wybierz plik</span>
            </div>
          </label>
        </b-form-group>
        <b-form-group
          v-if="file"
          label-cols-lg="3"
          label="Dokument:"
          label-for="document"
          label-align-lg="right"
        >
          <div class="dropfile-edit dropfile--documents">
            <span class="dropfile-name">{{ file.name }}</span
            ><small class="dropfile-size"
              >[ {{ humanFileSize(file.size) }} ]</small
            >
            <b-button class="btn" @click="removeFile">
              <i class="fas fa-trash-alt"></i>
            </b-button>
          </div>
        </b-form-group>
        <b-form-invalid-feedback :force-show="true">{{
          validationContext.errors[0]
        }}</b-form-invalid-feedback>
      </ValidationProvider>
    </ValidationObserver>
    <template v-slot:modal-footer="{ cancel }">
      <b-button
        :disabled="isBusy"
        size="md"
        variant="primary"
        type="submit"
        form="documentsForm"
        >Zapisz</b-button
      >
      <b-button size="md" variant="outline-danger" @click="cancel()"
        >Anuluj</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { humanFileSize } from "@/services/helpers";
import DocumentsService from "@/services/documents.service";

export default {
  name: "ModalDocuments",
  data() {
    return {
      editedItem: null,
      isBusy: false,
      document_name: "",
      file: null,
    };
  },
  computed: {
    title() {
      return this.isEdited
        ? "Edytuj dokument: " +
            this.editedItem.name +
            "." +
            this.editedItem.extension
        : "Dodaj nowy dokument";
    },

    isEdited() {
      return !!this.editedItem;
    },
  },
  methods: {
    show(editedItem) {
      this.editedItem = editedItem ? { ...editedItem } : {};
      if (editedItem) {
        this.document_name = this.editedItem.name;
        this.file = {
          size: this.editedItem.size,
          name: this.editedItem.name + "." + this.editedItem.extension,
        };
      }
      this.$nextTick(() => {
        this.$bvModal.show("documents-modal");
      });
    },
    onClose() {
      this.document_name = "";
      this.file = null;
      this.isBusy = false;
    },

    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },

    onSubmit() {
      this.$refs.documentsForm.validate().then((success) => {
        if (!success) {
          return;
        }
        this.isBusy = true;
        const document_name = this.document_name;
        const bodyFormData = new FormData();
        if (document_name && document_name !== "") {
          bodyFormData.set("name", document_name);
        }

        if (this.file && this.file instanceof File) {
          bodyFormData.append("document", this.file);
        }
        this.$Progress.start();
        return DocumentsService.add(
          bodyFormData,
          this.isEdited ? this.editedItem.id : false
        )
          .then((newDocument) => {
            this.$emit("onSubmitSuccess", newDocument.data);
            this.$nextTick(() => {
              this.$bvModal.hide("documents-modal");
            });
          })
          .catch((error) => {
            this.$refs.documentsForm.setErrors(error.response.data.fields);
            return [];
          })
          .finally(() => {
            this.isBusy = false;
          });
      });
    },
    onFileChange() {
      this.file = this.$refs.document.files[0];
    },
    removeFile() {
      this.file = false;
    },
    dropFile(event) {
      event.preventDefault();
      this.$refs.document.files = event.dataTransfer.files;
      this.onFileChange();
      event.currentTarget.classList.remove("on");
    },
    dragover(event) {
      event.preventDefault();
      if (!event.currentTarget.classList.contains("on")) {
        event.currentTarget.classList.add("on");
      }
    },
    dragleave(event) {
      event.preventDefault();
      event.currentTarget.classList.remove("on");
    },
    humanFileSize,
  },
};
</script>
